var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('a',{staticClass:"article-inner",attrs:{"href":_vm.href}},[_c('span',{staticClass:"article-header"},[_vm._v(_vm._s(_vm.header))]),_c('span',{staticClass:"article-content"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }